// src/components/listing/ListFooter.jsx
import React from "react";

export default function ListFooter({
  page = 1,
  pageSize = 30,   // 👈 default defensivo
  total = 0,
  onPageChange,
}) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));

  const startIndex =
    total === 0 ? 0 : (page - 1) * pageSize + 1;

  const endIndex = Math.min(page * pageSize, total);

  const changePage = (num) => {
    const p = Math.min(Math.max(num, 1), totalPages);
    onPageChange(p);
  };

  return (
    <>
      {/* INFO */}
      <div className="mt-4 text-sm text-gray-600">
        {`${(total || 0).toLocaleString("es-PY")} registro${
          total === 1 ? "" : "s"
        }, mostrando de ${startIndex} a ${endIndex}.`}
      </div>

      {/* PAGINADOR */}
      {/* Cambio 1 */}
      <nav className="pager flex flex-wrap gap-1 justify-center">
        <button
          onClick={() => changePage(1)}
          disabled={page === 1}
          className={page === 1 ? "pager-off" : "pager-btn nav-btn text-white"}
        >
          Primera
        </button>

        <button
          onClick={() => changePage(page - 1)}
          disabled={page === 1}
          className={page === 1 ? "pager-off" : "pager-btn nav-btn text-white"}
        >
          Anterior
        </button>

        {[...Array(totalPages)].map((_, i) => {
          const num = i + 1;

          if (
            num === 1 ||
            num === totalPages ||
            (num >= page - 2 && num <= page + 2)
          ) {
            return (
              <button
                key={num}
                onClick={() => changePage(num)}
                className={page === num ? "pager-active" : "pager-btn"}
              >
                {num}
              </button>
            );
          }

          if (num === page - 3 || num === page + 3) {
            return (
              <span key={num} className="px-2 py-1">
                …
              </span>
            );
          }

          return null;
        })}

        <button
          onClick={() => changePage(page + 1)}
          disabled={page === totalPages}
          className={`${page === totalPages ? "pager-off" : "pager-btn nav-btn text-white"}`}
        >
          Próxima
        </button>

        <button
          onClick={() => changePage(totalPages)}
          disabled={page === totalPages}
          className={`${page === totalPages ? "pager-off" : "pager-btn nav-btn text-white"}`}
        >
          Última
        </button>
      </nav>
    </>
  );
}
